import React from 'react';

/**
 * Visual + copy for draft line sync (uses syncUi from useCountOfflineDrafts only).
 * Optional Retry sync when showRetry is set (error or waiting) and onRetry is provided.
 * Optional Refresh page for recoverable sync issues.
 */
export default function CountSyncStatusStrip({ syncUi, className = '', onRetry, showRetry, retryBusy }) {
  if (!syncUi || !syncUi.headline) return null;
  const v = syncUi.variant || 'synced';
  const canRetry = Boolean(showRetry && onRetry && (v === 'error' || v === 'waiting'));
  const canRefresh = Boolean(syncUi.showRefreshButton && (v === 'error' || v === 'waiting'));
  return (
    <div className={`cs-sync-status-wrap ${className}`.trim()}>
      <div className={`cs-sync-status cs-sync-status--${v}`} role="status" aria-live="polite">
        <span className="cs-sync-status-badge">{syncUi.badgeLabel || syncUi.headline}</span>
        <div className="cs-sync-status-text">
          <strong className="cs-sync-status-headline">{syncUi.headline}</strong>
          {syncUi.detail ? <p className="cs-sync-status-detail">{syncUi.detail}</p> : null}
        </div>
      </div>
      {(canRetry || canRefresh) ? (
        <div className="cs-sync-actions">
          {canRetry ? (
            <button
              type="button"
              className="btn btn-sm btn-secondary cs-sync-retry-btn"
              onClick={() => onRetry()}
              disabled={retryBusy}
            >
              {retryBusy ? 'Retrying…' : 'Retry sync'}
            </button>
          ) : null}
          {canRefresh ? (
            <button
              type="button"
              className="btn btn-sm btn-secondary cs-sync-refresh-btn"
              onClick={() => {
                if (typeof window !== 'undefined') window.location.reload();
              }}
              disabled={retryBusy}
            >
              Refresh page
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
